import {
  Navigate,
  Route,
  HashRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { Box, CircularProgress } from "@mui/material";
import { isUserAuthenticated } from "./shared/utils/authUser";
import React, { lazy, useEffect, useState } from "react";
import { SIPProvider } from "./sip/SIPProvider";
import { SIPProviderOptions } from "./sip/type";
import OutboundingCall from "./pages/outboundingCall/OutboundingCall";
import { useLoading } from "./context/LoadingContext";
import LoadingComponent from "./components/LoadingComponents";
import CustomAppBar from "./components/CustomAppBar";
import { isPlatform } from "@ionic/core";
import ScrollToTop from "./ScrollToTop";
import useCustomMediaQuery from "./shared/mediaQuery/useCustomMediaQuery";
import MainLayoutOutlet from "./pages/layout/MainLayoutOutlet";

interface LayoutProps {
  children: React.ReactNode;
  styles?: React.CSSProperties;
}

const Login = lazy(() => import("./pages/auth/LoginPages"));
const Register = lazy(() => import("./pages/auth/Register"));
const SignupSucess = lazy(() => import("./pages/auth/SignupSucess"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));
const CompanyDetails = lazy(
  () => import("./pages/companyDetails/CompanyDetails")
);
const CallHistory = lazy(() => import("./pages/callHistory/CallHistory"));

const Loading: React.FC = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
  >
    <CircularProgress />
  </Box>
);

const sipOptions: SIPProviderOptions = {
  domain: "93.127.162.61",
  webSocketServer: "wss://chat.musadan.com/realtime/ws",
  authorizationUsername: "agent2",
  authorizationPassword: "password134",
  register: false,
  refAudioRemote: undefined,
  refVideoRemote: undefined,
};

const Layout: React.FC<LayoutProps> = ({ styles, children }) => {
  const isPlatformCordova = isPlatform("cordova");
  const { isSmall } = useCustomMediaQuery();
  return (
    <>
      <div
        className="app-route-content"
        style={{
          marginLeft: isPlatformCordova ? 16 : isSmall ? 25 : "60px",
          marginRight: isPlatformCordova ? 16 : isSmall ? 25 : "60px",
          ...styles,
        }}
      >
        {children}
      </div>
    </>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkIfUserAuthenticated = async () => {
    const userAuthenticated = await isUserAuthenticated();
    setIsAuthenticated(userAuthenticated);
  };

  useEffect(() => {
    checkIfUserAuthenticated();
  }, [isUserAuthenticated]);

  const { isLoading } = useLoading();
  return (
    <div
      className="App"
      // style={{ backgroundImage: `url(${BackgroundImage})`, minHeight: "100vh" }}
    >
      <SIPProvider options={sipOptions}>
        <Router>
          {isLoading && <LoadingComponent />}
          <ScrollToTop />
          <MainLayoutOutlet>
          <Routes>
            
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-success" element={<SignupSucess />} />
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <CustomAppBar />
                  <Dashboard />
                </Layout>
              }
            />
            <Route
              path="/outbounding-call"
              element={
                <Layout>
                  <CustomAppBar />
                  <OutboundingCall />
                </Layout>
              }
            />
            <Route
              path="/company-details"
              element={
                <Layout>
                  <CustomAppBar />
                  <CompanyDetails />
                </Layout>
              }
            />
            <Route
              path="/call-history"
              element={
                <Layout>
                  <CustomAppBar />
                  <CallHistory />
                </Layout>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </MainLayoutOutlet>
        </Router>
      </SIPProvider>
    </div>
  );
};

export default App;
